import { MCBHS060InitRequest } from 'types/MCBHS060/MCBHS060InitRequest'
import { MCBHS060Request } from 'types/MCBHS060/MCBHS060Request'
import { MCBHS060DraftRequest } from 'types/MCBHS060/MCBHS060DraftRequest'

export interface InitResult {
  mcbDestinationInfo: MessageUtilMcbMessagesDetail[]
  destinationInfo: DestinationResult[]
  submissionContent: SubmissionResult
  destinationDivision: string
  senderCompanyName: string
  senderMailAddress: string
  subject: string
  body: string
  submissionDeadlineKind: string
  submissionDeadlineDay: string
  submissionDeadlineHour: string
  resubmitReceptionFlag: string
  sendTimeFlag: string
  signature: SignResult[]
  companyId: number
  forbiddenWord: string[]
  searchCriteria: string
  searchCriteriaName: string
  searchCriteriaJson: string
  sysVersionNumber: number
  sendReplyImpossibleTime: SendReplyImpossibleTime[]
  // 27KH #130241 START
  companyServiceEndDate: string
  // 27KH #130241 END
  // 28KH #181571 start
  messageTemplate: MCAZS220MessageTemplateResultDto[]
  draftMessageTemplateSettingId: number
  // 28KH #181571 end
}

// 28KH #181571 start
export interface MCAZS220MessageTemplateResultDto {
  [key: string]: any
  messageTemplateSettingId: number
  templateName: string
  templateType: string
  destinationDivision: string
  senderCompanyName: string
  senderMailAddress: string
  replayPermitFlag: string
  subject: string
  body: string
  reservedScheduleSendFlag: string
  sequence: number
  replyNecessaryFlag: string // 要返信フラグ
  replyLimitTime: string // 返信期限
  sysVersionNumber: string // sysバージョン番号
}
// 28KH #181571 end

export interface SubmissionRequestObj {
  // 企業別求職者ID
  jobSeekerByCompanyId: string

  // 提出リクエストID
  submissionRequestId: string
}

export interface MessageUtilMcbMessagesDetail {
  notSend: boolean
  entryId: string
  selectionManagementId: string
  submissionRequestId: string
  jobSeekerByCompanyId: string
  mycareercd: string
  mcbMemberId: string
  mcbSubmissionRequestId: string
  jobSeekerId: string
  coordinationFormerJobSeekerIdentificationKey: string
  // 26KH #89293 START
  originJobSeekerId: string
  originJobSeekerByCompanyId: string
  // 26KH #89293 END
}
export interface DestinationResult {
  entryId: string
  jobSeekerIdForDisplay: string
  familyName: string
  name: string
  birthdate: Date
  mailAddress: string
  memberType: string
  unsubscribedJobSeekerId: number
  mcbUseStatus: string
  schoolName: string
  facultyName: string
  subjectName: string
  entryReceptionTime: Date
  coordinationFormerJobSeekerIdentificationKey: string
  // #MCB1.5次開発 #8997 START
  //閲覧権限
  readableFlag: string
  // #MCB1.5次開発 #8997 END
}
export interface SubmissionResult {
  [key: string]: any
  submissionRequestId: number
  submissionContentId: string
  submissionContentName: string
  submissionContentNameStudent: string
  submissionEntrySheetFlag: number
  submissionResumeFlag: number
  submissionResearchSummaryFlag: number
  submissionOriginalQuestionFlag: number
  submissionFileSubmissionFlag: number
}
const submissionResult: SubmissionResult={
  submissionRequestId: 0,
  submissionContentId: '',
  submissionContentName: '',
  submissionContentNameStudent: '',
  submissionEntrySheetFlag: 0,
  submissionResumeFlag: 0,
  submissionResearchSummaryFlag: 0,
  submissionOriginalQuestionFlag: 0,
  submissionFileSubmissionFlag: 0,
}

export interface SendReplyImpossibleTime {
  rowNoStr: string
  // #MCB1.5次開発 #8986 START
  functionalDivisionStr: string
  // #MCB1.5次開発 #8986 END
  startDateStr: string
  endDateStr: string
}

export interface SignResult {
  signSettingId: string
  registrationName: string
  signature: string
}
export interface PreviewResult {
  entryId: number
  familyName: string
  name: string
  jobSeekerIdForDisplay: string
  submissionRequestUrl: string
}

const messageInitRequest: MCBHS060InitRequest = {
  searchCriteriaName: '',
  searchCriteria: '',
  draftMessageSendID: '',
  sysVersionNumber: '',
  jobSeekerByCompanyIdSubmissionRequestIdList: [],
}
const destinationResultDto: DestinationResult = {
  entryId: '',
  jobSeekerIdForDisplay: '',
  familyName: '',
  name: '',
  birthdate: new Date(),
  mailAddress: '',
  memberType: '',
  unsubscribedJobSeekerId: 0,
  mcbUseStatus: '',
  schoolName: '',
  facultyName: '',
  subjectName: '',
  entryReceptionTime: new Date(),
  coordinationFormerJobSeekerIdentificationKey: '',
  // #MCB1.5次開発 #8997 START
  readableFlag: '',
  // #MCB1.5次開発 #8997 END
}

const initResult: InitResult = {
  mcbDestinationInfo: [],
  destinationInfo: [],
  submissionContent:submissionResult,
  destinationDivision: '',
  senderCompanyName: '',
  senderMailAddress: '',
  subject: '',
  body: '',
  submissionDeadlineKind: '',
  submissionDeadlineDay: '',
  submissionDeadlineHour: '',
  resubmitReceptionFlag: '',
  sendTimeFlag: '',
  signature: [],
  companyId: 0,
  forbiddenWord: [],
  searchCriteria: '',
  searchCriteriaName: '',
  searchCriteriaJson: '',
  sysVersionNumber:0,
  sendReplyImpossibleTime: [],
  // 27KH #130241 START
  companyServiceEndDate: '',
  // 27KH #130241 END
  // 28KH #181571 start
  draftMessageTemplateSettingId: 0,
  messageTemplate: [],
  // 28KH #181571 end
}

const confirmRequest: MCBHS060Request = {
  destinationId: [],
  searchCriteriaName: '',
  searchCriteria: '',
  submissionsSelectId: '',
  limitDateDetermineFlag: 0,
  dateTimeDetermineDate: '',
  requestDayTimeLaterDay: 0,
  requestDayTimeToTime: 0,
  anytimeReceptionEndDate: '',
  reRequestReceptFlag: 0,
  replyCompanyName: '',
  replyMailAddress: '',
  deadlineChangeSubject: '',
  deadlineChangeText: '',
  messageUtilMcbMessagesDetailDtoList: [],
  // 28KH #181571 start
  messageTemplateSettingId: '0',
  // 28KH #181571 end
}
const draftRequest: MCBHS060DraftRequest = {
  destinationId: [],
  searchCriteriaName: '',
  searchCriteria: '',
  // 9174 start
  searchCriteriaJson: '',
  // 9174 end
  submissionsSelectId: '',
  limitDateDetermineFlag: 0,
  dateTimeDetermineDate: '',
  requestDayTimeLaterDay: 0,
  requestDayTimeToTime: 0,
  anytimeReceptionEndDate: '',
  reRequestReceptFlag: 0,
  replyCompanyName: '',
  replyMailAddress: '',
  deadlineChangeSubject: '',
  deadlineChangeText: '',
  sysVersionNumber: 0,
  messageUtilMcbMessagesDetailDtoList: [],
  sourceDraftMessageSendId: '',
  // 28KH #181571 start
  messageTemplateSettingId: '0',
  // 28KH #181571 end
}
export {
  initResult,
  messageInitRequest,
  destinationResultDto,
  confirmRequest,
  draftRequest,
}
